export const GET_STAFF_ALERTS_REQUEST = 'GET_STAFF_ALERTS_REQUEST';
export const GET_STAFF_ALERTS_SUCCESS = 'GET_STAFF_ALERTS_SUCCESS';
export const GET_STAFF_ALERTS_FAILURE = 'GET_STAFF_ALERTS_FAILURE';

export const UPDATE_STAFF_ALERT_REQUEST = 'UPDATE_STAFF_ALERT_REQUEST';
export const UPDATE_STAFF_ALERT_SUCCESS = 'UPDATE_STAFF_ALERT_SUCCESS';
export const UPDATE_STAFF_ALERT_FAILURE = 'UPDATE_STAFF_ALERT_FAILURE';

export const GET_NEXT_STAFF_ALERT = 'GET_NEXT_STAFF_ALERT';



// WEBPACK FOOTER //
// ./src/store/modules/alerts/mutation-types.js